// Monk FBT widget: turn the "(10% off)" labels into "10% off" badges.
// Text nodes are edited in place so React keeps its references on re-render.
(() => {
  const stripParens = (root) => {
    root.querySelectorAll('.mr-embedded-widget--fbt .mr-price-con__off').forEach((label) => {
      const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      if (nodes.length === 0) return;

      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (!first.data.trimStart().startsWith('(') || !last.data.trimEnd().endsWith(')')) return;

      first.data = first.data.replace(/^\s*\(/, '');
      last.data = last.data.replace(/\)\s*$/, '');
    });
  };

  // The heading comes from the Monk app settings as "People&nbsp;<wbr>also&nbsp;<wbr>bought".
  const renameHeading = (root) => {
    root.querySelectorAll('.mr-embedded-widget--fbt > div:first-child p').forEach((heading) => {
      if (heading.textContent.replace(/\s+/g, ' ').trim() !== 'People also bought') return;

      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      nodes.forEach((node, index) => {
        node.data = index === 0 ? 'Frequently bought together' : '';
      });
    });
  };

  // Copy the "This item" product name onto the total row; CSS renders it via attr().
  const labelTotal = (root) => {
    root.querySelectorAll('.mr-embedded-widget--fbt').forEach((widget) => {
      const total = widget.querySelector('.mr-fbt-total-con');
      const name = widget.querySelector(
        '.mr-fbt-product-name-con__this-item ~ .mr-fbt-product-name-con__product-name'
      );
      if (!total || !name) return;

      const text = name.textContent.trim();
      if (total.dataset.productName !== text) total.dataset.productName = text;
    });
  };

  const fix = (root) => {
    stripParens(root);
    renameHeading(root);
    labelTotal(root);
  };

  document.querySelectorAll('.main-product-emojibator').forEach((section) => {
    fix(section);
    new MutationObserver(() => fix(section)).observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  });
})();
